module.exports = __webpack_public_path__ + "media/images/thumbs-down-icon-7d3320b79aed13f7f4fc7f7fef4fbdd5.png";